import { Ethnicity } from '@/models';
import { GenericService } from './generic.service';

export class EthnicityService extends GenericService<Ethnicity> {
  constructor() {
    super('v1/ethnicities');
  }
}
